import { combineReducers } from 'redux';
import authReducer from 'auth/authReducer';
import appReducer from 'state/appReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  app: appReducer,
});

export default rootReducer;